import axios from "axios";
import { MessageBox, Message } from "element-ui";
import store from "@/store";
import router from "@/router"
// import { getToken, setToken } from "@/utils/auth";

export const URL_ENV = {
  // serverHost: "http://39.103.228.66:7077",
  serverHost: "https://reportapi.ouraivision.com",
  // serverHost: "http://192.168.0.108:7077"
};
const service = axios.create({
  baseURL: URL_ENV.serverHost,
  timeout: 10000, // 10s
  headers: {
    "Content-Type": "application/json;charset=utf-8"
  }
});
// request interceptor
service.interceptors.request.use(
  config => {
    // 请求头携带token
    // if (getToken()) {
    //   config.headers["token"] = getToken();
    // }
    if (!config.noAuth) {
      if (localStorage.getItem('token')) {
        config.headers["token"] = localStorage.getItem('token')
      } else {
        router.push({
          path:'/login',
          query: router.history.current.query
        })
      }
    }

    return config;
  },
  error => {
    // do something with request error
    console.log(error); // for debug
  }
);

// response interceptor
service.interceptors.response.use(
  response => {
    const res = response.data;
    if (res.code == 200) {
      return res;
    } else if (res.code == 21001) {
      Message({
        message: res.message,
        type: "error",
        duration: 1 * 1000
      });
      setTimeout(() => {
        router.push({
          path:'/login',
          query: router.history.current.query
        })
      }, 1000);
    } else {
      Message({
        message: res.message,
        type: "error",
        duration: 2 * 1000
      });
    }

  },
  error => {
    console.log("err" + error); // for debug
    Message({
      message: "网络不给力，请稍后再试",
      type: "error",
      duration: 3 * 1000
    });
    return Promise.reject(error);
  }
);
export default service;



// WEBPACK FOOTER //
// ./src/utils/request.js